<template>
  <section class="page_404">
    <div v-if="!$_.isUndefined(this.$route.params.page)" class="container">
      <div class="row">
        <div class="col-12">
          <div class="item-wrapper text-center">
            <div class="four_zero_four_bg">
              <h1 class="text-center">404</h1>
            </div>
            <div class="contant_box_404">
              <h3 class="h2">Look like you're lost</h3>
              <p>the page you are looking for not avaible!</p>
              <a href="/" class="link_404">Go to Home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  beforeCreate() {
    if (_.isUndefined(this.$route.params?.page)) {
      let hasRedirect = false
      this.$util.options.menu.forEach((menu) => {
        if (!hasRedirect && menu.type == 'menu' && _.isString(menu.url)) {
          hasRedirect = true
          window.location.href = menu.url
        }
      })
    }
  },
  mounted() {
    document.body.classList.add(`page-404`, 'loaded')
    if (_.isUndefined(this.$route.params?.page)) {
      this.$util.isLoading(this.$el)
    }
  }
}
</script>

<style lang="scss">
body.page-404 {
  .app-sidebar,
  .app-page-title {
    display: none !important;
  }
  .app-main__outer {
    padding-left: 0 !important;
  }
  .page_404 {
    height: 100vh;
    width: 100vw;
    padding: 40px 0;
    background: #fff;
    img {
      width: 100%;
    }
  }
  .item-wrapper {
    width: 100%;
    max-width: 900px;
    margin: auto;
  }
  .four_zero_four_bg {
    background-image: url('@/../assets/imgs/dribbble_1.gif');
    height: 400px;
    background-position: center;
    h1 {
      font-size: 80px;
    }
    h3 {
      font-size: 80px;
    }
  }
  .link_404 {
    color: #fff !important;
    padding: 10px 20px;
    background: #39ac31;
    margin: 20px 0;
    display: inline-block;
  }
  .contant_box_404 {
    margin-top: -50px;
  }
}
</style>
